import { EmbeddedRouteName } from '@/shared/enums';

export default [
  {
    path: '/:slug,:type-:id',
    name: EmbeddedRouteName.PLAYER,
    component: () => import('../views/player.vue'),
    meta: {
      noindex: true,
    },
  },
  {
    path: '/:slug,:type-:id/:articleSlug,:articleType-:articleId',
    name: EmbeddedRouteName.PLAYER_WITH_ARTICLE,
    component: () => import('../views/player.vue'),
    meta: {
      noindex: true,
    },
  },
  {
    path: '/:slug,:type-:id/:articleSlug,:articleType-:articleId/:fallbackType-:fallbackId',
    name: EmbeddedRouteName.PLAYER_WITH_FALLBACK,
    component: () => import('../views/player.vue'),
    meta: {
      noindex: true,
    },
  },
];
